export default {

    debug: process.env.NODE_ENV === 'development'

};
